import {z} from 'zod';
import {
	editRemovesFromFilter,
	getDefaultFilters,
	type EditRemovesFromFilterParams,
	type GetDefaultFiltersParams,
} from '@netx/core-next/schema';
import {
	DownloadRequestSchema,
	DownloadRequestReviewStatus,
	type IDownloadRequest,
} from './downloadRequestScheme';

export const DownloadRequestFilterSchema = z.object({
	filterStatus: z.array(z.nativeEnum(DownloadRequestReviewStatus)).nullable(),
	filterText: z.string().nullable(),
});

export const DownloadRequestsFilterableField =
	DownloadRequestFilterSchema.keyof().enum;

export const DOWNLOAD_REQUEST_FILTERABLE_FIELDS = Object.values(
	DownloadRequestsFilterableField,
);

export const DOWNLOAD_REQUESTS_DEFAULT_FILTER_REVIEW_STATUS = [
	DownloadRequestReviewStatus.PENDING,
];

export type DownloadRequestsFilter = z.infer<
	typeof DownloadRequestFilterSchema
>;

/** will return the filters passed in if valid/specified, otherwise will return the defaults for the invalid/unspecified */
export const getDownloadRequestsDefaultFilters = (
	params?: Omit<
		GetDefaultFiltersParams<DownloadRequestsFilter>,
		'filterableFields'
	>,
): DownloadRequestsFilter =>
	getDefaultFilters({
		...params,
		filterableFields: DOWNLOAD_REQUEST_FILTERABLE_FIELDS,
	});

/** given the original data, the new data, and the current filters, determine if the record should still be included in the filtered list */
export const downloadRequestEditRemovesFromFilter = (
	params: Omit<
		EditRemovesFromFilterParams<IDownloadRequest, DownloadRequestsFilter>,
		'schema'
	>,
) =>
	editRemovesFromFilter({
		...params,
		schema: DownloadRequestSchema,
	});
